/** Build a `tel:` href from a display phone string. */
export function resolveTelHref(phoneNumber: string): string {
  const trimmed = phoneNumber.trim();
  if (!trimmed) {
    return '#';
  }
  const digits = trimmed.replace(/[^\d+]/g, '');
  if (!digits) {
    return '#';
  }
  return `tel:${digits}`;
}

/** External booking / messenger URL; empty → `#` (safe placeholder in edit mode). */
export function resolveExternalHref(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return '#';
  }
  if (/^(https?:|mailto:|tel:|sms:)/i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith('/') || trimmed.startsWith('#')) {
    return trimmed;
  }
  return `https://${trimmed}`;
}
